import React from 'react';
import { Grid, Box } from '@mui/material';
import SenhaAtualPanel from './SenhaAtualPanel';
import FilaPasswordsList from './FilaPasswordsList';
import HistoricoSenhas from './HistoricoSenhas';

const DashboardLayout = ({
  // Props para SenhaAtualPanel
  senhaChamada,
  atendimentoIniciado,
  atendimentoFinalizado,
  tempoAtendimento,
  rechamando,
  formatarTempo,
  handleIniciarAtendimento,
  handleFinalizarAtendimento,
  handleMostrarDialogoNaoCompareceu,
  handleReabrirSenha,
  handleRechamarSenha,
  handleAdicionarServicos,
  
  // Props do aviso de aguardo na fila
  aguardandoNaFila,
  mensagemAguardo,
  
  // Props para FilaPasswordsList
  senhasOrdenadas,
  handleClicarSenha,
  handleChamarProxima,
  carregando,
  chamadaEmAndamento,
  aguardandoChamada,
  
  // Props para HistoricoSenhas
  senhasProcessadas,
  user,
  forceHistoricoRefresh,
  
  // Props gerais
  customTheme,
  sidebarOpen = false // Nova prop para controlar responsividade
}) => {
  return (
    <Grid container spacing={{ xs: 2, sm: sidebarOpen ? 2 : 3, md: 3 }}>
      {/* Painel da senha atual */}
      <Grid item 
        xs={12} 
        sm={sidebarOpen ? 12 : 12} 
        md={sidebarOpen ? 12 : 6} 
        lg={sidebarOpen ? 6 : 4}
        xl={4}
      >
        <Box sx={{ height: { xs: 'auto', md: '100%' } }}>
          <SenhaAtualPanel
            senhaChamada={senhaChamada}
            atendimentoIniciado={atendimentoIniciado}
            atendimentoFinalizado={atendimentoFinalizado}
            tempoAtendimento={tempoAtendimento}
            rechamando={rechamando}
            formatarTempo={formatarTempo}
            handleIniciarAtendimento={handleIniciarAtendimento}
            handleFinalizarAtendimento={handleFinalizarAtendimento}
            handleMostrarDialogoNaoCompareceu={handleMostrarDialogoNaoCompareceu}
            handleReabrirSenha={handleReabrirSenha}
            handleRechamarSenha={handleRechamarSenha}
            handleAdicionarServicos={handleAdicionarServicos}
            customTheme={customTheme}
            aguardandoNaFila={aguardandoNaFila}
            mensagemAguardo={mensagemAguardo}
          />
        </Box>
      </Grid>

      {/* Painel da fila de espera */}
      <Grid item 
        xs={12} 
        sm={sidebarOpen ? 6 : 6} 
        md={sidebarOpen ? 6 : 6} 
        lg={sidebarOpen ? 3 : 4}
        xl={4}
      >
        <Box sx={{ 
          height: { xs: 'auto', md: '100%' }, 
          maxHeight: { xs: '400px', md: '500px' },
          minHeight: { xs: '300px', md: '400px' }
        }}>
          <FilaPasswordsList
            proximasSenhas={senhasOrdenadas}
            handleClicarSenha={handleClicarSenha}
            handleChamarProxima={handleChamarProxima}
            carregando={carregando}
            customTheme={customTheme}
            chamadaEmAndamento={chamadaEmAndamento}
            aguardandoChamada={aguardandoChamada}
            senhaChamada={senhaChamada}
            atendimentoFinalizado={atendimentoFinalizado}
          />
        </Box>
      </Grid>

      {/* Painel do histórico */}
      <Grid item 
        xs={12} 
        sm={sidebarOpen ? 6 : 6} 
        md={sidebarOpen ? 6 : 12} 
        lg={sidebarOpen ? 3 : 4}
        xl={4}
      >
        <Box sx={{ 
          height: { xs: 'auto', md: '100%' }, 
          maxHeight: { xs: '400px', md: '500px' },
          minHeight: { xs: '300px', md: '400px' }
        }}>
          <HistoricoSenhas
            senhasProcessadas={senhasProcessadas}
            customTheme={customTheme}
            user={user}
            forceRefresh={forceHistoricoRefresh}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default DashboardLayout; 